<template>
  <div class="form-group">
    <label v-if="survey.id != 552" :style="template.style.surveyBgColor ? {color: template.style.firstColor } : {color: black}" class="title-bold">{{ questionText }}</label>
    <label v-else :style="template.style.surveyBgColor ? {color: template.style.firstColor } : 'color:#123654;'" class="title-bold">{{ questionText }}</label>
    <div>
      <vs-button
        :type="getBtnType('Sim')"
        ref="opcao1"
        :style="template.style.surveyBgColor ? {color: template.style.surveyTitleColor, borderColor: 'white'} : ''"
        class="no-shadow btn-block mb-2 btnOtion"
        @click="ChooseOption('Sim')"
        :disabled="processingApi"
      >
        Sim 
      </vs-button>
      <vs-button
        :type="getBtnType('Não')"
        ref="opcao1"
        :style="template.style.surveyBgColor ? {color: template.style.surveyTitleColor, borderColor: 'white'} : ''"
        class="no-shadow btn-block mb-2 btnOtion"
        @click="ChooseOption('Não')"
        :disabled="processingApi"
      >
        Não 
      </vs-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Survey-Yes-No",
  data: () => ({
    qtAnwser: "",
    dataOk: false,
    show: false,
    processingApi: false,
  }),

  props: {
    questionText: { type: String },
    questionId: { type: Number }
  },

  mounted: function() {
    this.qtAnwser = this.$store.getters.answerValue(this.questionId);
  },
  methods: {
    getBtnType(val) {
      if (this.qtAnwser == val) return "filled";
      else return "border";
    },

    ChooseOption(opt) {
      this.qtAnwser = opt;
      this.enterKey();
    },
    enterKey() {
      if (this.qtAnwser === 'Não') this.processingApi = true
      this.$emit("QuestionAnwered", this.qtAnwser, this.questionId).then(() => this.processingApi = false);
    }
  },
  computed: {
    template() {
      return this.$store.state.template;
    },
    survey() {
      return this.$store.state.template.survey;
    },
  }
};
</script>

<style scoped>
.title-bold{
  font-family:'OxaniumBold';
}

.no-shadow{
    color: var(--survey-text-color) !important;
}

.no-shadow:hover{
  -webkit-box-shadow: 0 0px 0px 0px rgba(var(--vs-primary),0);
  box-shadow: 0 0px 0px 0px rgba(var(--vs-primary),0);
}

/*
.q-title {
  font-size: 21px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #40424a;
}

.q-list-answer {
  width: 351px;
  height: 40px;
  font-size: 24px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.08;
  letter-spacing: normal;
  color: #40424a;
  display: inline-block;
  vertical-align: middle;
}

.q-text-answer .text-style-1 {
  color: #bf9f61;
} */
</style>
